import { render } from "./CheckboxFilter.vue?vue&type=template&id=72d3b754"
import script from "./CheckboxFilter.vue?vue&type=script&lang=js"
export * from "./CheckboxFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__